/**
 * description:
 * dateTime: 2024/8/20-下午5:51
 * author: ZhangJun 1580043700@qq.com
 */
import {SDrawer, SFormUploadImage, SGeneralForms} from "shj-components";
import {Form, message} from "antd";
import {useEffect} from "react";
import {IConfig} from "shj-components/dist/es/SGeneralForms/type";
import config from "@/config";
import {useRequest} from "ahooks";
import {queryMemberEquityCategoryList, queryMemberEventList, saveOrUpdateMemberEquity} from "@/services/member.ts";

const getImage = list => {
    return (list || []).map(item => item.url ?? item?.response?.data?.fileUrl)
}

function EditContent(props) {

    const [form] = Form.useForm();
    const {loading: loadingEdit, runAsync: runEdit} = useRequest(saveOrUpdateMemberEquity, {
        manual: true,
    })

    const {data: memberEquityCategoryList} = useRequest(queryMemberEquityCategoryList, {defaultParams: [{data: {}}]});
    const {data: memberEventList} = useRequest(queryMemberEventList, {defaultParams: [{state: true}]});

    useEffect(() => {
        form.resetFields();
        const data = props?.data || {};
        form.setFieldsValue({
            ...data,
            imageUrl: data?.imageUrl ? [{url: data?.imageUrl}] : null,
        });
    }, [props.data])

    const onSubmit = () => {
        form.validateFields().then(values => {
            console.log('values', values.imageUrl)
            runEdit({
                ...(props.data || {}),
                ...values,
                imageUrl: values.imageUrl ? getImage(values.imageUrl)?.[0] : null,
            }).then(() => {
                message.success('保存成功')
                props.destroy(true);
            })
        })
    }

    const formatUploadData = (urls: Array<any>) => {
        return urls.map(item => ({
            url: item.response ? item.response?.data?.fileUrl : item.url,
            name: item.response ? item.response?.data?.originalFilename : item.name,
        }))
    }

    const configs: Array<IConfig> = [
        {
            title: '会员权益库',
            formItem: [
                {
                    label: '权益名称',
                    name: 'name',
                    required: true,
                    spanCol: 24
                },
                {
                    label: '权益分类',
                    name: 'equityCategoryId',
                    required: true,
                    type: 'tree',
                    comConfig: {
                        treeData: memberEquityCategoryList,
                        fieldNames: {label: 'name', value: 'id', children: 'childList',},
                        disabled: !!props.data?.id
                    },
                    spanCol: 24,
                },
                {
                    label: '关联会员事件',
                    name: 'memberEventId',
                    type: 'select',
                    comConfig: {
                        options: memberEventList,
                        fieldNames: {label: 'name', value: 'id'},
                        disabled: !!props.data?.id
                    },
                    spanCol: 24
                },
                {
                    label: '排序',
                    name: 'orderSeq',
                    required: true,
                    type: 'inputNumber',
                    spanCol: 24,
                    comConfig: {
                        min: 0,
                        precision: 0
                    }
                },
                {
                    label: '状态',
                    name: 'state',
                    type: 'switch',
                    spanCol: 24
                },
                {
                    label: '图标',
                    name: 'imageUrl',
                    spanCol: 24,
                    children: (<SFormUploadImage
                        url={config.api + '/file-web/file/upload'}
                        setFileUrl={formatUploadData}
                        accept='image/*' maxCount={1}/>)
                },
                {
                    label: '权益描述',
                    name: 'description',
                    type: 'textarea',
                    maxLength: 100,
                    spanCol: 24
                }
            ]
        }
    ]

    return (
        <SDrawer open={props.open} title={props.data?.id ? '编辑' : '新增'} onSubmit={onSubmit} width={500}
                 onClose={() => props.destroy(false)} loading={loadingEdit}>
            <SGeneralForms layout='vertical' formConfig={{form}} configs={configs}></SGeneralForms>
        </SDrawer>
    )
}

export default EditContent;
